import { seoLinks, absoluteUrl, ogImage } from "@/lib/seo";
import { createFileRoute } from "@tanstack/react-router";

import { PrivacyPolicyContent } from "@/components/site/EnrollmentPolicyContent";

import { PageHero, PolicyBody } from "../../components/site/Page";

const title = "Privacy policy | Swedish International School";
const description =
  "How Swedish International School Estepona–Marbella handles personal data in applications, school placement and contact with guardians.";

export const Route = createFileRoute("/en/privacy-policy")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "article" },
      { property: "og:url", content: absoluteUrl("/en/privacy-policy") },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:locale", content: "en_GB" },
      ...ogImage(),
    ],
    links: seoLinks("/en/privacy-policy"),
  }),
  component: PrivacyPolicy,
});

function PrivacyPolicy() {
  return (
    <>
      <PageHero
        eyebrow="Privacy"
        title="Privacy policy"
        intro="Here we describe which personal data the school collects via the website and application form, why we do so, and how you can influence the processing."
      />

      <PolicyBody>
        <PrivacyPolicyContent locale="en" />
      </PolicyBody>
    </>
  );
}
